import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';

import Tasks from 'APP/Tasks';
import { RouterLink } from 'APP/router/constants';
import Entities from 'STORE';

export function useActiveSpaceHandlerPresenter(): void {
  const isSpace = useMatch(`${RouterLink.Space}/*`);

  useEffect(() => {
    if (isSpace) {
      Tasks.space.setActiveSpace(isSpace.params.id);
    }
  }, [isSpace]);

  useEffect(() => {
    const group = Entities.GroupsStore.activeGroup;
    const spaceId = group?.parentGroup?.spaceId || group?.spaceId;

    if (!isSpace && Entities.spacesStore.activeSpaceId !== spaceId) {
      Tasks.space.setActiveSpace(null);
    }
  }, [Entities.GroupsStore.activeGroup, isSpace]);
}
